/* Variety Discounted theme script. No dependencies. */
(function () {
  'use strict';

  var T = window.theme || {};
  T.strings = T.strings || {};
  T.routes = T.routes || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '${{amount}}';
    var value = Number(cents) || 0;
    function fmt(n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(value, 0, ' ', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
    return out.replace(/<[^>]*>/g, '');
  }
  function moneyNoTrailingZeros(cents) {
    return formatMoney(cents).replace(/([.,])00(?!\d)/, '');
  }
  T.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Drawers ---------- */
  var overlay = $('[data-overlay]');
  var openDrawerEl = null;
  var lastFocus = null;

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer(openDrawerEl, false);
    lastFocus = trigger || document.activeElement;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('is-locked');
    openDrawerEl = drawer;
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var focusTarget = $('[data-drawer-close]', drawer) || drawer;
      focusTarget.focus({ preventScroll: true });
    }, 60);
  }

  function closeDrawer(drawer, restoreFocus) {
    drawer = drawer || openDrawerEl;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (openDrawerEl === drawer) {
      openDrawerEl = null;
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('is-locked');
      if (restoreFocus !== false && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.target.closest('[data-overlay]')) closeDrawer();

    var cartOpener = e.target.closest('[data-cart-open]');
    if (cartOpener && T.cartType === 'drawer' && $('[data-cart-drawer]') && !document.querySelector('[data-cart-page]')) {
      e.preventDefault();
      openDrawer($('[data-cart-drawer]'), cartOpener);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawerEl) {
      closeDrawer();
      return;
    }
    if (e.key === 'Tab' && openDrawerEl) {
      var focusable = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', openDrawerEl)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.addEventListener('resize', debounce(function () {
    if (openDrawerEl && openDrawerEl.hasAttribute('data-facets') && isDesktop()) closeDrawer(openDrawerEl, false);
    if (openDrawerEl && openDrawerEl.id === 'MenuDrawer' && isDesktop()) closeDrawer(openDrawerEl, false);
  }, 150));

  /* ---------- Header ---------- */
  // On phones the sticky header slides away while scrolling down and returns on scroll up.
  var header = $('[data-header]');
  if (header) {
    var headerSection = header.closest('.shopify-section') || header.parentElement;
    var sticky = header.classList.contains('header-wrapper--sticky');
    var lastY = window.scrollY;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 4);
      if (sticky && !isDesktop() && !openDrawerEl) {
        var searching = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-predictive-search]');
        if (y > lastY + 8 && y > 200 && !searching) headerSection.classList.add('is-hidden');
        else if (y < lastY - 8 || y <= 200) headerSection.classList.remove('is-hidden');
      } else {
        headerSection.classList.remove('is-hidden');
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Desktop dropdowns: one open at a time, close on outside click, open on hover.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-nav-dropdown]') || !d.open) return;
    $$('[data-nav-dropdown][open]').forEach(function (other) { if (other !== d) other.open = false; });
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-dropdown]')) {
      $$('[data-nav-dropdown][open]').forEach(function (d) { d.open = false; });
    }
  });
  if (window.matchMedia('(hover: hover)').matches) {
    $$('[data-nav-dropdown]').forEach(function (d) {
      var timer;
      d.parentElement.addEventListener('mouseenter', function () { clearTimeout(timer); d.open = true; });
      d.parentElement.addEventListener('mouseleave', function () { timer = setTimeout(function () { d.open = false; }, 150); });
    });
  }

  /* ---------- Announcement rotation ---------- */
  function initAnnouncements(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar._rotating) return;
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      bar._rotating = true;
      var i = 0;
      var ms = (Number(bar.getAttribute('data-interval')) || 5) * 1000;
      var next = function () {
        items[i].hidden = true;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].hidden = false;
        items[i].classList.add('is-active');
      };
      var timer = setInterval(next, ms);
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('focusin', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', function () { clearInterval(timer); timer = setInterval(next, ms); });
    });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    sectionIds: function () {
      var ids = ['cart-icon-bubble'];
      if ($('[data-cart-drawer]')) ids.push('cart-drawer');
      var page = $('[data-cart-page]');
      if (page) ids.push(page.getAttribute('data-section-id'));
      return ids;
    },
    request: function (url, body, isForm) {
      var opts = {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      };
      if (!isForm) opts.headers['Content-Type'] = 'application/json';
      return fetch(url, opts).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw data;
          return data;
        });
      });
    },
    add: function (formData) {
      formData.append('sections', Cart.sectionIds().join(','));
      formData.append('sections_url', window.location.pathname);
      return Cart.request(T.routes.cartAdd + '.js', formData, true).then(function (data) {
        Cart.render(data.sections);
        return data;
      });
    },
    change: function (line, quantity) {
      var body = JSON.stringify({ line: line, quantity: quantity, sections: Cart.sectionIds(), sections_url: window.location.pathname });
      return Cart.request(T.routes.cartChange + '.js', body).then(function (data) {
        Cart.render(data.sections);
        return data;
      });
    },
    refresh: function () {
      var url = window.location.pathname + '?sections=' + encodeURIComponent(Cart.sectionIds().join(','));
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sections) { Cart.render(sections); })
        .catch(function () {});
    },
    note: function (note) {
      return Cart.request(T.routes.cartUpdate + '.js', JSON.stringify({ note: note }));
    },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = parseHTML(html);
        if (id === 'cart-icon-bubble') {
          var bubble = document.getElementById('cart-icon-bubble');
          var fresh = doc.getElementById('shopify-section-cart-icon-bubble');
          if (bubble && fresh) {
            bubble.innerHTML = fresh.innerHTML;
            var count = $('[data-cart-count]', bubble);
            if (count) count.classList.add('is-bumped');
          }
        } else if (id === 'cart-drawer') {
          var drawer = $('[data-cart-drawer]');
          var freshDrawer = doc.querySelector('[data-cart-drawer]');
          if (drawer && freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
        } else {
          var page = $('[data-cart-page]');
          var freshPage = doc.querySelector('[data-cart-page]');
          if (page && freshPage) page.innerHTML = freshPage.innerHTML;
        }
      });
    }
  };
  T.cart = Cart;

  function setButtonsLoading(buttons, loading) {
    buttons.forEach(function (btn) {
      var label = $('[data-add-label]', btn);
      if (loading) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-disabled', 'true');
        if (label) { label._text = label.textContent; label.textContent = T.strings.adding || 'Adding'; }
      } else {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
        if (label && label._text) label.textContent = label._text;
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (form.matches('[data-product-form], [data-quick-add]')) {
      if (T.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
      e.preventDefault();
      var buttons = $$('[data-add-button]', form);
      if (form.id) buttons = buttons.concat($$('[form="' + form.id + '"][data-add-button]'));
      if (buttons.some(function (b) { return b.classList.contains('is-loading') || b.disabled; })) return;
      var errorEl = $('[data-form-error]', form);
      if (errorEl) errorEl.hidden = true;
      setButtonsLoading(buttons, true);
      Cart.add(new FormData(form))
        .then(function () {
          openDrawer($('[data-cart-drawer]'), e.submitter || buttons[0]);
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || T.strings.cartError;
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          else toast(msg);
        })
        .then(function () { setButtonsLoading(buttons, false); });
      return;
    }

    if (form.matches('[data-facets-form]')) {
      e.preventDefault();
      Facets.applyForm(form);
      return;
    }

    if (form.matches('[data-confirm]')) {
      if (!window.confirm(form.getAttribute('data-confirm'))) e.preventDefault();
    }
  });

  // Quantity steppers (product form and cart lines)
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = input.min === '' ? 0 : Number(input.min);
    var max = input.max === '' ? 9999 : Number(input.max);
    var value = (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-qty-step'));
    input.value = Math.max(min, Math.min(max, value));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var lineTimers = {};
  function changeLine(input, quantity) {
    var isEl = input && typeof input === 'object';
    var line = Number(isEl ? input.getAttribute('data-line-qty') : input);
    var li = isEl ? input.closest('[data-line-item]') : null;
    var scope = (li && (li.closest('[data-cart-drawer]') || li.closest('[data-cart-page]'))) || document;
    if (li) li.classList.add('is-updating');
    var activeId = document.activeElement && document.activeElement.id;
    Cart.change(line, quantity)
      .then(function () {
        var status = $('[data-cart-status]', scope);
        if (status) status.textContent = '';
        if (activeId) {
          var again = document.getElementById(activeId);
          if (again) again.focus({ preventScroll: true });
        }
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || T.strings.cartError;
        Cart.refresh().then(function () {
          var errorEl = $('[data-cart-error]', scope.isConnected ? scope : document);
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          else toast(msg);
        });
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches('[data-line-qty]')) {
      var key = input.getAttribute('data-line-qty');
      clearTimeout(lineTimers[key]);
      lineTimers[key] = setTimeout(function () {
        changeLine(input, Math.max(0, parseInt(input.value, 10) || 0));
      }, 350);
    }
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    var li = remove.closest('[data-line-item]');
    var input = li && $('[data-line-qty]', li);
    changeLine(input || remove.getAttribute('data-line-remove'), 0);
  });

  document.addEventListener('input', debounce(function (e) {
    if (e.target.matches && e.target.matches('[data-cart-note]')) Cart.note(e.target.value).catch(function () {});
  }, 500));

  /* ---------- Product page ---------- */
  function initProduct(section) {
    if (!section || section._init) return;
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    try { section._product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    section._init = true;
    markAvailability(section);
    initStickyBar(section);
  }

  function selectedOptions(section) {
    var picker = $('[data-variant-picker]', section);
    if (!picker) return null;
    var values = [];
    $$('[data-option-index]', picker).forEach(function (el) {
      var i = Number(el.getAttribute('data-option-index'));
      if (el.tagName === 'SELECT') values[i] = el.value;
      else if (el.checked) values[i] = el.value;
    });
    return values;
  }

  function findVariant(product, options) {
    return product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    })[0] || null;
  }

  function markAvailability(section) {
    var product = section._product;
    var current = selectedOptions(section);
    if (!product || !current) return;
    $$('[data-option-index]', section).forEach(function (el) {
      var i = Number(el.getAttribute('data-option-index'));
      var check = function (value) {
        return product.variants.some(function (v) {
          if (!v.available || v.options[i] !== value) return false;
          return v.options.every(function (o, j) { return j === i || current[j] === undefined || o === current[j]; });
        });
      };
      if (el.tagName === 'SELECT') {
        $$('option', el).forEach(function (opt) {
          var base = opt.getAttribute('data-label') || opt.textContent.trim();
          opt.setAttribute('data-label', base);
          opt.textContent = check(opt.value) ? base : base + ' (' + (T.strings.soldOut || 'Sold out') + ')';
        });
      } else {
        var label = el.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !check(el.value));
      }
    });
  }

  function saveLabel(price, compare) {
    var diff = compare - price;
    var amount = T.savingsStyle === 'amount' ? moneyNoTrailingZeros(diff) : Math.round(diff * 100 / compare) + '%';
    return (T.strings.save || 'Save [amount]').replace('[amount]', amount);
  }

  function updateProduct(section) {
    var product = section._product;
    var options = selectedOptions(section);
    if (!product || !options) return;
    var variant = findVariant(product, options);

    $$('[data-selected-value]', section).forEach(function (el) {
      el.textContent = options[Number(el.getAttribute('data-selected-value'))] || '';
    });
    markAvailability(section);

    var buttons = $$('[data-add-button]', section);
    var idInput = $('form[data-product-form] input[data-variant-id]', section);  // only the cart form's field (app widgets also use data-variant-id)

    if (!variant) {
      buttons.forEach(function (b) {
        b.disabled = true;
        var l = $('[data-add-label]', b);
        if (l) l.textContent = T.strings.unavailable || 'Unavailable';
      });
      return;
    }

    if (idInput) idInput.value = variant.id;
    buttons.forEach(function (b) {
      b.disabled = !variant.available;
      var l = $('[data-add-label]', b);
      if (l) l.textContent = variant.available ? (T.strings.addToCart || 'Add to cart') : (T.strings.soldOut || 'Sold out');
    });

    var onSale = variant.compare_at_price > variant.price;
    var priceEl = $('.product__price [data-price]', section) || $('[data-price]', section);
    if (priceEl) {
      priceEl.classList.toggle('price--on-sale', onSale);
      priceEl.classList.toggle('price--sold-out', !variant.available);
      var finalEl = $('[data-price-final]', priceEl);
      if (finalEl) finalEl.textContent = formatMoney(variant.price);
      var compareWrap = $('[data-price-compare-wrap]', priceEl);
      if (compareWrap) compareWrap.hidden = !onSale;
      var compareEl = $('[data-price-compare]', priceEl);
      if (compareEl) compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      var saveEl = $('[data-price-save]', priceEl);
      if (saveEl) {
        saveEl.hidden = !onSale;
        saveEl.textContent = onSale ? saveLabel(variant.price, variant.compare_at_price) : '';
      }
      var unitEl = $('[data-price-unit]', priceEl);
      if (unitEl) {
        unitEl.hidden = !variant.unit_price;
        unitEl.textContent = variant.unit_price ? formatMoney(variant.unit_price) + '/' + variant.unit_label : '';
      }
    }
    var gallerySave = $('[data-gallery-save]', section);
    if (gallerySave) {
      gallerySave.hidden = !onSale;
      gallerySave.textContent = onSale ? saveLabel(variant.price, variant.compare_at_price) : '';
    }
    var stickyPrice = $('[data-sticky-price]', section);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    var stock = $('[data-stock]', section);
    if (stock) {
      var state = 'in';
      var text = T.strings.inStock || 'In stock';
      var threshold = Number(T.lowStockThreshold) || 0;
      if (!variant.available) {
        state = 'out';
        text = T.strings.soldOut || 'Sold out';
      } else if (variant.inventory_quantity !== null && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
        state = 'low';
        text = (T.strings.lowStock || 'Only [quantity] left').replace('[quantity]', variant.inventory_quantity);
      }
      stock.className = 'stock stock--' + state;
      var stockText = $('[data-stock-text]', stock);
      if (stockText) stockText.textContent = text;
    }

    var sku = $('[data-sku]', section);
    if (sku) {
      sku.hidden = !variant.sku;
      var skuValue = $('[data-sku-value]', sku);
      if (skuValue) skuValue.textContent = variant.sku || '';
    }

    if (variant.featured_media_id) showMedia($('[data-gallery]', section), variant.featured_media_id);

    var errorEl = $('[data-form-error]', section);
    if (errorEl) errorEl.hidden = true;

    if (section.hasAttribute('data-product-url')) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.pathname + url.search);
    }
  }

  document.addEventListener('change', function (e) {
    var opt = e.target.closest && e.target.closest('[data-option-index]');
    if (!opt) return;
    var section = opt.closest('[data-product-section]');
    if (section) { initProduct(section); updateProduct(section); }
  });

  // Gallery
  function showMedia(gallery, id) {
    if (!gallery) return;
    var found = false;
    $$('.gallery__slide', gallery).forEach(function (slide) {
      var match = String(slide.getAttribute('data-media-id')) === String(id);
      if (match) found = true;
      slide.hidden = !match;
      slide.classList.toggle('is-active', match);
    });
    if (!found) return;
    $$('[data-media-target]', gallery).forEach(function (thumb) {
      thumb.setAttribute('aria-current', String(thumb.getAttribute('data-media-target')) === String(id) ? 'true' : 'false');
    });
    $$('.gallery__slide video', gallery).forEach(function (v) { if (v.closest('[hidden]')) v.pause(); });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-target]');
    if (thumb) {
      showMedia(thumb.closest('[data-gallery]'), thumb.getAttribute('data-media-target'));
      return;
    }
    var nav = e.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (nav) {
      var gallery = nav.closest('[data-gallery]');
      var slides = $$('.gallery__slide', gallery);
      var index = slides.findIndex(function (s) { return !s.hidden; });
      var dir = nav.hasAttribute('data-gallery-next') ? 1 : -1;
      var next = slides[(index + dir + slides.length) % slides.length];
      if (next) showMedia(gallery, next.getAttribute('data-media-id'));
    }
  });

  // Sticky add-to-cart bar appears once the main button scrolls off screen.
  function initStickyBar(section) {
    var bar = $('[data-sticky-atc]', section);
    var main = $('.product-form__submit', section);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      $$('button', bar).forEach(function (b) { b.tabIndex = past ? 0 : -1; });
    });
    io.observe(main);
  }

  // Share
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url') || window.location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast(T.strings.linkCopied || 'Link copied'); });
    }
  });

  /* ---------- Predictive search ---------- */
  function initPredictive(form) {
    if (form._ps || !T.predictiveSearch) return;
    form._ps = true;
    var input = $('input[name="q"]', form);
    var results = $('[data-predictive-results]', form);
    var clear = $('[data-search-clear]', form);
    if (!input) return;
    var controller = null;
    var lastTerm = '';

    function close() {
      if (results) results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    function items() { return results ? $$('[data-ps-item]', results) : []; }
    function select(index) {
      var list = items();
      list.forEach(function (el, i) { el.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
      if (list[index]) {
        input.setAttribute('aria-activedescendant', list[index].id);
        list[index].scrollIntoView({ block: 'nearest' });
      }
    }
    function escapeHTML(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function imageUrl(src, width) {
      if (!src) return '';
      try {
        var u = new URL(src, window.location.origin);
        u.searchParams.set('width', width);
        return u.toString();
      } catch (err) { return src; }
    }

    function render(term, data) {
      if (!results) return;
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var queries = (res.queries || []).filter(function (q) { return q.text && q.text.toLowerCase() !== term.toLowerCase(); }).slice(0, 4);
      var html = '';
      var n = 0;
      if (queries.length) {
        html += '<div class="predictive__group"><p class="predictive__heading">' + escapeHTML(T.strings.suggestions || 'Suggestions') + '</p><ul class="predictive__list" role="group">';
        queries.forEach(function (q) {
          html += '<li><a id="ps-item-' + (n++) + '" data-ps-item role="option" aria-selected="false" class="predictive__item predictive__item--text" href="' + escapeHTML(q.url) + '">' +
            '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/></svg>' +
            '<span class="predictive__title">' + (q.styled_text || escapeHTML(q.text)) + '</span></a></li>';
        });
        html += '</ul></div>';
      }
      if (products.length) {
        html += '<div class="predictive__group"><p class="predictive__heading">' + escapeHTML(T.strings.products || 'Products') + '</p><ul class="predictive__list" role="group">';
        products.forEach(function (p) {
          var price = Math.round(parseFloat(p.price || 0) * 100);
          var compare = Math.round(parseFloat(p.compare_at_price_max || 0) * 100);
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          html += '<li><a id="ps-item-' + (n++) + '" data-ps-item role="option" aria-selected="false" class="predictive__item" href="' + escapeHTML(p.url) + '">' +
            (img ? '<img class="predictive__img" src="' + escapeHTML(imageUrl(img, 120)) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="predictive__img"></span>') +
            '<span class="predictive__title">' + escapeHTML(p.title) + '</span>' +
            (T.predictiveShowPrice ? '<span class="predictive__price' + (compare > price ? ' is-sale' : '') + '">' + escapeHTML(formatMoney(price)) + '</span>' : '<span></span>') +
            '</a></li>';
        });
        html += '</ul></div>';
      }
      if (!products.length && !queries.length) {
        html += '<p class="predictive__empty">' + escapeHTML((T.strings.noResults || 'No results for "[terms]"').replace('[terms]', term)) + '</p>';
      }
      html += '<button type="submit" id="ps-item-' + (n++) + '" data-ps-item role="option" aria-selected="false" class="predictive__all"><span>' +
        escapeHTML((T.strings.searchFor || 'Search for "[terms]"').replace('[terms]', term)) +
        '</span><svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg></button>';
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    var search = debounce(function () {
      var term = input.value.trim();
      if (clear) clear.hidden = !input.value;
      if (!term) { close(); return; }
      if (term === lastTerm && results && !results.hidden) return;
      lastTerm = term;
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = T.routes.predictiveSearch + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value.trim() === term) render(term, data); })
        .catch(function () {});
    }, 180);

    input.addEventListener('input', search);
    input.addEventListener('focus', function () {
      if (input.value.trim() && results && results.innerHTML) { results.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    });
    input.addEventListener('keydown', function (e) {
      if (!results || results.hidden) return;
      var list = items();
      var current = list.findIndex(function (el) { return el.getAttribute('aria-selected') === 'true'; });
      if (e.key === 'ArrowDown') { e.preventDefault(); select(Math.min(list.length - 1, current + 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); select(Math.max(0, current - 1)); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && current >= 0 && list[current].tagName === 'A') { e.preventDefault(); window.location.href = list[current].href; }
    });
    if (clear) {
      clear.hidden = !input.value;
      clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; close(); input.focus(); });
    }
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  /* ---------- Filters and sorting ---------- */
  var Facets = {
    urlFromForm: function (form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    },
    applyForm: function (form) {
      var section = form.closest('[data-facets-section]') || $('[data-facets-section]');
      Facets.load(section, Facets.urlFromForm(form));
    },
    load: function (section, url) {
      if (!section) { window.location.href = url; return; }
      var target = new URL(url, window.location.origin);
      var fetchUrl = new URL(target.toString());
      fetchUrl.searchParams.set('section_id', section.getAttribute('data-section-id'));
      section.setAttribute('aria-busy', 'true');
      var grid = $('#ProductGridContainer', section);
      if (grid) grid.style.opacity = '.5';
      fetch(fetchUrl.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parseHTML(html).querySelector('[data-facets-section]');
          if (!fresh) { window.location.href = target.toString(); return; }
          if (openDrawerEl && section.contains(openDrawerEl)) closeDrawer(openDrawerEl, false);
          section.innerHTML = fresh.innerHTML;
          section.removeAttribute('aria-busy');
          window.history.pushState({ facets: true }, '', target.pathname + target.search);
          var top = section.querySelector('.collection-layout');
          if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function () { window.location.href = target.toString(); });
    }
  };

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches && el.matches('[data-facet-sort]')) {
      var form = el.form || document.getElementById(el.getAttribute('form'));
      if (form) Facets.applyForm(form);
      return;
    }
    var form2 = el.closest && el.closest('[data-facets-form]');
    if (form2 && isDesktop()) Facets.applyForm(form2);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-facet-link]');
    if (!link) return;
    var section = link.closest('[data-facets-section]');
    if (!section) return;
    e.preventDefault();
    Facets.load(section, link.getAttribute('href'));
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.facets) window.location.reload();
  });

  /* ---------- Product recommendations ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el._loaded || !el.getAttribute('data-url')) return;
      el._loaded = true;
      var load = function () {
        fetch(el.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = parseHTML(html).querySelector('[data-recommendations]');
            if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else {
        load();
      }
    });
  }

  /* ---------- Accounts ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-account-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var id = toggle.getAttribute('data-account-toggle');
    var target = document.getElementById(id);
    if (!target) return;
    if (id === 'Recover' || id === 'Login') {
      var login = document.getElementById('Login');
      var recover = document.getElementById('Recover');
      if (login) login.hidden = id !== 'Login';
      if (recover) recover.hidden = id !== 'Recover';
    } else {
      target.hidden = !target.hidden;
    }
    var field = $('input:not([type="hidden"])', target);
    if (field && !target.hidden) field.focus();
  });
  if (window.location.hash === '#recover' || window.location.hash === '#Recover') {
    var rec = document.getElementById('Recover');
    var log = document.getElementById('Login');
    if (rec && log) { rec.hidden = false; log.hidden = true; }
  }

  function initAddressForms() {
    if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;
    $$('[data-address-country]').forEach(function (select) {
      var prefix = select.getAttribute('data-address-country');
      if (select._cps) return;
      select._cps = true;
      new window.Shopify.CountryProvinceSelector('AddressCountry-' + prefix, 'AddressProvince-' + prefix, {
        hideElement: 'AddressProvinceWrap-' + prefix
      });
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-autosubmit]') && e.target.form) e.target.form.submit();
  });

  /* ---------- Init ---------- */
  // The sticky header is its own stacking context, so a drawer left inside it would sit under
  // the page overlay. Move such drawers to <body>, replacing any copy left by an editor reload.
  function hoistDrawers(root) {
    $$('[data-hoist]', root).forEach(function (drawer) {
      if (drawer.parentElement === document.body) return;
      $$('body > [data-hoist]').forEach(function (old) { if (old.id === drawer.id) old.remove(); });
      document.body.appendChild(drawer);
    });
  }

  function init(root) {
    root = root || document;
    hoistDrawers(root);
    initAnnouncements(root);
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-predictive-search]', root).forEach(initPredictive);
    initRecommendations(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initAddressForms(); });
  } else {
    init();
    initAddressForms();
  }
  window.addEventListener('load', initAddressForms);

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openDrawer($('[data-cart-drawer]'));
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) closeDrawer();
  });
})();
